import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { deleteUserRequest, copyIP } from '../actions/userActions';
import { permissionsSelector } from '../../auth/selectors/authSelectors';
import UserItem from '../components/UserItem/UserItem';

const mapStateToProps = createStructuredSelector({ permissions: permissionsSelector });
const mapDispatchToProps = {
    deleteUserRequest,
    copyIP
};

export default connect(mapStateToProps, mapDispatchToProps)(UserItem);
